import type { ZodType } from "zod";
import z from "zod";

import { requiredInvolvementKinds } from "../rules/requiredInvolvementKinds.js";

export type RequiredInvolvement = (typeof requiredInvolvementKinds)[number];

export type PersonState =
  | { kind: "active" }
  | { kind: "unassigned"; missing: RequiredInvolvement[] }
  | { kind: "archived" };

export const PersonStateSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("active") }),
  z.object({
    kind: z.literal("unassigned"),
    missing: z.array(z.enum(requiredInvolvementKinds)),
  }),
  z.object({ kind: z.literal("archived") }),
]) satisfies ZodType<PersonState>;
